"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _identity = _interopRequireDefault(require("transmute/identity"));

var _atom = require("atom");

var _classnames = _interopRequireDefault(require("classnames"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _immutable = require("immutable");

var _omit = _interopRequireDefault(require("transmute/omit"));

var _PropertyValueDisplay = require("customer-data-property-utils/PropertyValueDisplay");

var _ReferenceResolverType = _interopRequireDefault(require("reference-resolvers/schema/ReferenceResolverType"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _PropertyRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyRecord"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _utils = require("reference-resolvers/utils");

var _PropertySourceTypes = require("customer-data-objects/property/PropertySourceTypes");

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var DATA_1 = 'hs_analytics_source_data_1';
var DATA_2 = 'hs_analytics_source_data_2';
var SOURCE = 'hs_analytics_source';
var IMPORT_SOURCE_VALUES = (0, _immutable.Seq)(['OFFLINE', 'IMPORTED']);

var isFromImport = function isFromImport(getProperty, subject) {
  if (!subject) {
    return null;
  }

  var source = getProperty(subject, SOURCE);
  var data1 = getProperty(subject, DATA_1);
  return IMPORT_SOURCE_VALUES.includes(source) && data1 === _PropertySourceTypes.IMPORT;
};

var isFromIntegration = function isFromIntegration(getProperty, subject) {
  if (!subject) {
    return null;
  }

  var data1 = getProperty(subject, DATA_1);
  return data1 === _PropertySourceTypes.INTEGRATION;
};

var propTypes = {
  InputComponent: _react.PropTypes.func.isRequired,
  getProperty: _react.PropTypes.func,
  objectType: _ObjectTypesType.default.isRequired,
  onChange: _react.PropTypes.func.isRequired,
  property: _react.PropTypes.instanceOf(_PropertyRecord.default).isRequired,
  readOnlySourceData: _react.PropTypes.shape({
    isKnownGuid: _react.PropTypes.func.isRequired,
    getGuidLabel: _react.PropTypes.func.isRequired
  }).isRequired,
  resolver: _ReferenceResolverType.default.isRequired,
  subject: _SubjectType.default,
  value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  className: _react.PropTypes.string
};
var defaultProps = {
  options: (0, _immutable.List)()
};
var initialState = {
  referencedValue: {}
};

var getValueDependentDisplayValue = function getValueDependentDisplayValue(name, value, subject, getProperty, _ref) {
  var isKnownGuid = _ref.isKnownGuid,
      getGuidLabel = _ref.getGuidLabel;
  var displayValue = null;

  switch (name) {
    case DATA_1:
      displayValue = isKnownGuid(value) ? getGuidLabel(value) : '';
      break;

    case DATA_2:
      if (isKnownGuid(value)) {
        displayValue = getGuidLabel(value);
      } else if (!isFromImport(getProperty, subject) && !isFromIntegration(getProperty, subject)) {
        displayValue = '';
      }

      break;

    default:
      displayValue = null;
  }

  return displayValue;
};

var getReferencedObjectDependendentDisplayValue = function getReferencedObjectDependendentDisplayValue(name, referencedObject, objectType) {
  var displayValue;

  switch (name) {
    case 'hubspot_team_id':
      displayValue = referencedObject.get('name');
      break;

    case 'dealstage':
      displayValue = objectType === _ObjectTypes.DEAL ? referencedObject.get('text') : '';
      break;

    case 'pipeline':
      displayValue = objectType === _ObjectTypes.DEAL ? referencedObject.get('label') : '';
      break;

    case 'hs_parent_company_id':
      displayValue = objectType === _ObjectTypes.COMPANY ? referencedObject.toString() : '';
      break;

    case 'salesforcecampaignids':
      if (objectType === _ObjectTypes.CONTACT) {
        displayValue = referencedObject.map(function (campaign) {
          return campaign ? campaign.get('name') || campaign.get('id') : null;
        }).filter(_identity.default).join(', ');
      }

      break;

    case DATA_2:
      displayValue = referencedObject.get('importName') || referencedObject.get('importname') || referencedObject.get('integrationName');
      break;

    case 'hs_analytics_first_touch_converting_campaign':
    case 'hs_analytics_last_touch_converting_campaign':
      displayValue = referencedObject.get('display_name');
      break;

    default:
      displayValue = '';
  }

  return displayValue;
};

var ReferenceDisplayValue =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ReferenceDisplayValue, _React$Component);

  function ReferenceDisplayValue() {
    var _this;

    (0, _classCallCheck2.default)(this, ReferenceDisplayValue);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ReferenceDisplayValue).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = initialState;
    _this.referenceAtom = null;
    return _this;
  }

  (0, _createClass2.default)(ReferenceDisplayValue, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.watchReferenceAtom(this.props.value);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        this.unwatchReferenceAtom(this.props.value);
        this.watchReferenceAtom(nextProps.value);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unwatchReferenceAtom(this.props.value);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.refs.input.focus();
    }
  }, {
    key: "watchReferenceAtom",
    value: function watchReferenceAtom(value) {
      if (!(0, _utils.isResolved)(value)) {
        return;
      }

      this.referenceAtom = this.props.resolver.byId(value);
      (0, _atom.watch)(this.referenceAtom, this.handleReferencedValueChange);
      this.handleReferencedValueChange((0, _atom.deref)(this.referenceAtom));
    }
  }, {
    key: "unwatchReferenceAtom",
    value: function unwatchReferenceAtom(value) {
      if (!(0, _utils.isResolved)(value)) {
        return;
      }

      (0, _atom.unwatch)(this.referenceAtom, this.handleReferencedValueChange);
      this.referenceAtom = null;
    }
  }, {
    key: "shouldRenderTooltip",
    value: function shouldRenderTooltip(referencedDisplayValue) {
      var _this$props = this.props,
          property = _this$props.property,
          value = _this$props.value;
      var displayValue = (0, _PropertyValueDisplay.getDisplayedValue)(property, value);
      return displayValue && referencedDisplayValue && displayValue !== referencedDisplayValue;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var _this$props2 = this.props,
          property = _this$props2.property,
          objectType = _this$props2.objectType,
          value = _this$props2.value,
          subject = _this$props2.subject,
          readOnlySourceData = _this$props2.readOnlySourceData,
          getProperty = _this$props2.getProperty;

      if (!value) {
        return null;
      }

      var propertyName = property.get('name');
      var displayValue = getValueDependentDisplayValue(propertyName, value, subject, getProperty, readOnlySourceData);

      if (displayValue != null) {
        return displayValue;
      }

      var referencedValue = this.state.referencedValue;
      var referencedObject = referencedValue.referencedObject;

      if (!referencedObject) {
        return null;
      }

      return getReferencedObjectDependendentDisplayValue(propertyName, referencedObject, objectType);
    }
  }, {
    key: "handleReferencedValueChange",
    value: function handleReferencedValueChange(referencedValue) {
      if ((0, _utils.isResolved)(referencedValue)) {
        this.setState({
          referencedValue: referencedValue
        });
      }
    }
  }, {
    key: "renderWithTooltip",
    value: function renderWithTooltip(displayValue, transferableProps) {
      var _this$props3 = this.props,
          property = _this$props3.property,
          value = _this$props3.value,
          InputComponent = _this$props3.InputComponent,
          className = _this$props3.className;
      var originalValue = (0, _PropertyValueDisplay.getDisplayedValue)(property, value);

      var title = _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "recordProperties.original_value",
        options: {
          originalValue: originalValue
        }
      });

      var inputClassNames = (0, _classnames.default)(className, 'p-left-2');
      return _react.default.createElement("div", {
        className: "flex-row"
      }, _react.default.createElement(_UIHelpIcon.default, {
        className: "m-top-2",
        tooltipPlacement: "top right",
        title: title
      }), _react.default.createElement(InputComponent, (0, _extends2.default)({}, transferableProps, {
        value: displayValue,
        readOnly: true,
        className: inputClassNames
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          property = _this$props4.property,
          value = _this$props4.value,
          InputComponent = _this$props4.InputComponent;
      var referencedDisplayValue = this.getValue();
      var displayValue = referencedDisplayValue || (0, _PropertyValueDisplay.getDisplayedValue)(property, value);
      var transferableProps = (0, _omit.default)(['actions', 'baseUrl', 'isInline', 'InputComponent', 'getProperty', 'multiCurrencyCurrencyCode', 'objectType', 'onCancel', 'onInvalidProperty', 'options', 'onSecondaryChange', 'propertyIndex', 'readOnlySourceData', 'resize', 'resolver', 'secondaryChanges', 'showError', 'showPlaceholder', 'subject', 'subjectId', 'propertyInputComponentConfig'], this.props);

      if (this.shouldRenderTooltip(referencedDisplayValue)) {
        return this.renderWithTooltip(displayValue, transferableProps);
      }

      return _react.default.createElement(InputComponent, (0, _extends2.default)({}, transferableProps, {
        value: displayValue,
        ref: "input"
      }));
    }
  }]);
  return ReferenceDisplayValue;
}(_react.default.Component);

exports.default = ReferenceDisplayValue;
ReferenceDisplayValue.propTypes = propTypes;
ReferenceDisplayValue.defaultProps = defaultProps;
module.exports = exports.default;